/* eslint-disable no-undef */
import React, { Component } from 'react'
import {
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  NavLink } from 'reactstrap'

export default class NavBar extends Component {
  constructor(props) {
    super(props)

    this.toggle = this.toggle.bind(this)
    this.state = {
      isOpen: false,
      isTop: 'transparent'
    }
  }
  
  toggle() {
    this.setState({
      isOpen: !this.state.isOpen
    })
  }
  
  componentDidMount() {
    document.addEventListener('scroll', () => {
      const isTop = window.scrollY < 100
      if (isTop !== this.state.isTop) {
        this.setState({
          isTop: 'navbar-dark bg-dark'
        })
      } else {
        this.setState({
          isTop: 'transparent'
        })          
      }
    })      
  }
  
  render() {
    return (
      <div>
        <Navbar expand="md" fixed="top" className={this.state.isTop}>
          <NavbarBrand href="/"><img alt="Union City Smog Check" src="https://assets.unioncitysmogcheck.com/unioncitysmogshop/logo.png" /></NavbarBrand>
          <NavbarToggler onClick={this.toggle} />
          <Collapse isOpen={this.state.isOpen} navbar>
            <Nav className="ml-auto" navbar>
              <NavItem>
                <NavLink href="/#services">Services</NavLink>
              </NavItem>
              <NavItem>
                <NavLink href="/#about-us">About Us</NavLink>
              </NavItem>
              <NavItem>
                <NavLink href="/#smog-tips">Smog Tips</NavLink>
              </NavItem>
              <NavItem>
                <NavLink href="/#our-gift">Our Gift</NavLink>
              </NavItem>
              <NavItem>
                <NavLink href="/#contact-us">Contact Us</NavLink>
              </NavItem>
            </Nav>
          </Collapse>
        </Navbar>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/NavBar.js